import useContactos from "features/Contactos/hooks/useContactos"
import { setIsSelectFilterActive } from "features/Contactos/redux/slices/contactoSlice"
import { getUserModalSelectShape } from "features/Crear/constants"
import { setLibrador } from "features/Crear/redux/slices/newDocumentoSlice"
import { useDispatch } from "hooks/useDispatch"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

const useContactoSelector = (
  initialValue = null,
  initialIsCompradorState = true
) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isComprador, setIsComprador] = useState(initialIsCompradorState)
  const [contactoSelected, setContactoSelected] = useState(initialValue)
  const [showError, setShowError] = useState(false)
  const {
    currentContacto,
    getContactosBySelect,
    fetchingContactosBySelect,
    contactosBySelect,
    totalCount: totalContactos,
    handleSelectContacto,
    contacto,
    toggleShowCreateContacto,
  } = useContactos(setLibrador)

  useEffect(() => {
    if (currentContacto) {
      setContactoSelected(currentContacto)
    }
  }, [currentContacto])

  const handleCreateContacto = () => {
    const paginationNeeded = true
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
    dispatch(toggleShowCreateContacto(paginationNeeded, isComprador))
  }

  const onHandleScroll = (queryParams: $TSMigrationFixMe) => {
    getContactosBySelect(queryParams)
  }

  useEffect(() => {
    setIsComprador(initialIsCompradorState)
  }, [initialIsCompradorState])

  const {
    title,
    titlePagosCobros,
    options,
    placeholder,
    loading,
    fetch,
    userKey,
    setIsFilterActive,
    totalCount,
    handleSelect,
    value,
    transactionTypeValue,
  } = getUserModalSelectShape(
    isComprador,
    contactosBySelect,
    fetchingContactosBySelect,
    getContactosBySelect,
    totalContactos,
    setIsSelectFilterActive,
    handleSelectContacto,
    contacto,
    t
  )

  const handleSetIsComprador = (isComprador: $TSMigrationFixMe) => {
    setIsComprador(isComprador)
    setContactoSelected(null)
  }

  const onSelectContacto = (e: $TSMigrationFixMe, value: $TSMigrationFixMe) => {
    if (e) {
      setContactoSelected(e.target.value)
      handleSelect(e, value)
      setShowError(false)
    } else {
      setContactoSelected(value)
      const e = { target: { value: { id: value } } }
      handleSelect(e, value)
    }
  }
  return {
    onSelectContacto,
    contactoSelected,
    handleSetIsComprador,
    title,
    options,
    placeholder,
    loading,
    fetch,
    userKey,
    setIsFilterActive,
    totalCount,
    handleSelect,
    value,
    onHandleScroll,
    handleCreateContacto,
    isComprador,
    titlePagosCobros,
    transactionTypeValue,
    showError,
  }
}

export default useContactoSelector
